import angular from 'angular';

let PageController = function ($filter, $mdDialog, $scope, $state, $timeout, Page, Toast) {
  let $ctrl = this;

  $ctrl.name = $state.params.name;

  angular.extend($ctrl, {
    clearForm, handleSave
  });

  activate();

  function activate() {
    clearForm();

    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    
    let id = $ctrl.name;

    if (id) {
      $ctrl.uiState = 'LOADING';

      loadResource(id)
        .then(response => {
          simulateImageLoadProgress();
          $ctrl.page = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function clearForm(form) {
    $ctrl.page = {};
    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }

  function handleSave(form, page) {
    page.image_base64 = $ctrl.myCroppedImage;

    if (!form.$valid || (((!page.image_base64 && !page.image_uri) && page.name === 'about') || !page.content || page.content.trim().length < 12)) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    $ctrl.saving = true;

    Page
      .save(page)
      .then(response => {
        Toast.success($filter('translate')('page-detail-save-success'));
        $ctrl.page = response;
        $ctrl.myImage = '';
        $ctrl.myCroppedImage = '';
        $ctrl.fileName = undefined;
        $ctrl.saving = false;
      })
      .catch(err => {
        Toast.error($filter('translate')('common-save-error'));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }

  // Local functions

  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      console.log('no file added!');
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
      '  <md-dialog-content>'+
      '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">'+
      '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>'+
      '    </div>'+
      ''+
      '    <ui-cropper'+
      '      ng-show="isDoneLoading === true"'+
      '      on-load-done="isDoneLoading = true"'+
      '      image="myImage"'+
      '      area-type="rectangle"'+
      '      aspect-ratio="1.6744186047"'+
      '      init-max-area="true"'+
      '      chargement="loadingText"'+
      '      result-image-size="{w: 720,h: 430}"'+
      '      result-image="myCroppedImage" canvas-scalemode="true">'+
      '    </ui-cropper>'+
      '  </md-dialog-content>' +
      '  <md-dialog-actions' +
      '     ng-show="isDoneLoading === true">' +
      '    <md-button ng-click="cancel()">' +
      '      Cancelar' +
      '    </md-button>' +
      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
      '      Feito' +
      '    </md-button>' +
      '  </md-dialog-actions>' +
      '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    })
    .then(function(myCroppedImage) {
      $ctrl.myCroppedImage = myCroppedImage;
      $ctrl.myImage = '';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  }

  function DialogController($scope, $mdDialog, $filter) {
    "ngInject";
    $scope.loadingText = $filter('translate')('common-loading');
    $scope.myImage = $ctrl.myImage;
    $scope.myCroppedImage = $ctrl.myCroppedImage;

    $scope.hide = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function(myCroppedImage) {
      $mdDialog.hide(myCroppedImage);
    }
  }

  function loadResource(name) {
    return Page.show(name);
  }

  function simulateImageLoadProgress() {
    $ctrl.loadingImage = true;
    $timeout(function() {
      $ctrl.loadingImage = false;
    }, 1000);
  }
}

PageController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'Page', 'Toast'];

export default PageController;


// WEBPACK FOOTER //
// ./client/app/components/page/page.controller.js